const apiKey = "81fb53f355cc48feb9a567fc89195047";
const link = "https://www.cfe.mx/Pages/default.aspx";

export { apiKey, link };
